module.exports = __webpack_public_path__ + "media/images/front/icon_db_200_kisoigaku-ff428056962bff45f7699af32c2306f8.png";